import _extends from '@babel/runtime/helpers/extends';
import React from 'react';
import PropTypes from 'prop-types';
import { c as classNamePropTypes } from './classNames-1ed461aa.js';
import { m as marginPropTypes } from './spacing-0f39ba4a.js';
import { S as SvgIcon } from './SvgIcon-11e6ad98.js';

function IconFlag(props) {
  return /*#__PURE__*/React.createElement(SvgIcon, _extends({
    viewBox: "0 0 16 16"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M2 10V2c0-.177.07-.346.195-.471.146-.146.41-.322.807-.481C3.604.807 4.375.667 5.333.667c.944 0 1.588.184 2.914.714 1.174.47 1.697.619 2.419.619.792 0 1.396-.11 1.836-.286.228-.091.339-.165.36-.186A.666.666 0 0 1 14 1.999v8c0 .177-.07.346-.195.471-.146.146-.41.322-.807.481-.602.241-1.373.381-2.331.381-.944 0-1.588-.184-2.914-.714-1.174-.47-1.697-.619-2.419-.619-.792 0-1.396.11-1.836.286a2.37 2.37 0 0 0-.164.072v4.309a.667.667 0 1 1-1.334 0V9.999zm3.333-1.333c.944 0 1.588.184 2.914.714 1.174.47 1.697.619 2.419.619.792 0 1.396-.11 1.836-.286a2.37 2.37 0 0 0 .164-.072V3.068c-.546.169-1.21.264-2 .264-.944 0-1.588-.184-2.914-.714-1.174-.47-1.697-.619-2.419-.619-.792 0-1.396.11-1.836.286a2.37 2.37 0 0 0-.164.072v6.574c.546-.169 1.21-.264 2-.264z"
  }));
}
IconFlag.propTypes = {
  /** size of icon */
  size: PropTypes.oneOf(['sm', 'smd', 'md', 'mlg', 'lg', 'none']),
  /** CSS class to use, if any */
  className: classNamePropTypes,
  /** color, if not inheriting from parent's text color */
  color: PropTypes.oneOf(['ink', 'blurple', 'asphalt', 'lava', 'emerald', 'white']),
  /** margin for icon, if any */
  margin: marginPropTypes
};
IconFlag.defaultProps = {
  size: 'md',
  className: '',
  margin: null,
  color: null
};

export { IconFlag as default };
